import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MenusService } from 'src/app/services/menus.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { StoresService } from 'src/app/services/stores.service';

@Component({
  selector: 'app-menus-page',
  templateUrl: './menus-page.component.html',
  styleUrls: ['./menus-page.component.scss'],
})
export class MenusPageComponent implements OnInit {
  constructor(
    private storesService: StoresService,
    private menusServices: MenusService,
    private spiner: SpinnerService
  ) {}

  lat!: number;
  lng!: number;

  loading: any = true;

  menus: any = [];

  ngOnInit(): void {
    let element = document.querySelector('.tittle-navbar') as HTMLElement;
    element.innerHTML = 'Menus';
    this.loading = true;
    this.menusServices.getEventsWithMenu().subscribe((data) => {
      if (data.result) {
        this.menus = data.result;
      } else {
      }
      this.loading = false;
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
          }
        },
        (error: any) => console.log(error)
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }
}
